import { getStorageItem } from "./utils";

export const buildUpdateCustomerPayload = (
  { email, father_name = "" },
  { code: stateCode, label: state },
  { code: cityCode, label: city }
) => {
  return {
    cid: Number(getStorageItem("cid")),
    email,
    city,
    cityCode,
    state,
    stateCode,
    ...(father_name && { fatherName: father_name }),
  };
};

export const buildTerminateJourneyPayload = () => {
  return {
    oid: Number(getStorageItem("oid")),
    status: "JOURNEYTERMINATE",
    reason: getStorageItem("journeyCloseReason")
      ? getStorageItem("journeyCloseReason")
      : "",
  };
};

export const reBuildStateCityList = (list = []) => {
  if (!list.length) {
    return list;
  }

  list.map((item) => {
    item.label = item.description;
  });

  return list;
};
